import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const SobrenombreFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='ALIAS' htmlFor='select-sobrenombre' sm={2} alignRightAt='sm' />
      <Col sm={10}>
        <Field name='sobrenombre'>
          {({ field }) => <Form.InputText {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='select-sobrenombre' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(SobrenombreFormGroup)
